import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { College } from '../../../models/college.model';
import { CollegeService } from '../../../services/college.service';
import { CommonModule } from '@angular/common';
import { states } from '../../../constants';
import { EduEmailValidator } from '../../../validators/edu-email.validator';
import { Campus } from '../../../models/campus.model';
import { CampusService } from '../../../services/campus.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-create-campus-dialog',
  standalone: true,
  imports: [
    MatFormFieldModule,
    FormsModule,
    MatSelectModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    CommonModule,
    MatProgressBarModule,
  ],
  templateUrl: './create-campus-dialog.component.html',
  styleUrl: './create-campus-dialog.component.scss',
})
export class CreateCampusDialogComponent implements OnInit {
  loading: boolean = false;
  states = states;
  colleges: College[] = [];

  newCampusForm = new FormGroup({
    collegeId: new FormControl('', [Validators.required]),
    name: new FormControl('', Validators.required),
    emailDomain: new FormControl('', [Validators.required, EduEmailValidator]),
    status: new FormControl('ACTIVE'),
    street: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    zipcode: new FormControl('', Validators.required),
    isMainCampus: new FormControl(false, Validators.required),
  });

  constructor(
    private collegeService: CollegeService,
    private campusService: CampusService,
    private dialogRef: MatDialogRef<CreateCampusDialogComponent>
  ) {}

  ngOnInit(): void {
    this.collegeService.getAllColleges().subscribe({
      next: (response) => {
        this.colleges = response;
      },
    });
  }

  submit() {
    this.loading = true;
    const newCampus: Campus = this.newCampusForm.value as Campus;
    this.campusService.create(newCampus).subscribe({
      next: () => {
        this.loading = false;
        this.dialogRef.close({
          message: 'Campus created successfully!',
        });
      },
      error: () => {
        this.loading = false;
        this.dialogRef.close({
          message: 'Campus could not be created. Please try again.',
        });
      },
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
}
